import React from 'react'
import PropTypes from 'prop-types'
import {Link} from "react-router-dom"
import ProductType from "./ProductType"
import classNames from "classnames"
import {Tag} from "antd"
import moment from "moment"

BatchesRows.propTypes = {
    item: PropTypes.object,
    onChangeProductType: PropTypes.func.isRequired
}

function BatchesRows(props) {
    const {item, onChangeProductType, handleChangeInput} = props
    const {status, partner, sewing_partner, brand, production_times} = item

    const color = classNames({
        'pending progress-bar-animated progress-bar-striped': status === 'pending' || status === 'processing',
        'printing progress-bar-animated progress-bar-striped': status === 'printing',
        'printed': status === 'printed',
        'transferring progress-bar-animated progress-bar-striped': status === 'transferring',
        'transferred': status === 'transferred',
        'confirmed': status === 'confirmed',
        'wait-sew progress-bar-animated progress-bar-striped': status === 'wait_to_sew',
        'sewing': status === 'sewing',
        'completed': status === 'completed' || status === 'done',
    })

    function _generateLevel(level) {
        const color = level === 'highest' ? 'rgb(255 45 0)' : level === 'high' ? '#FFD300' : ''
        return (
            <div>
                <Tag
                    className={classNames(`tag-${level}`)}
                    color={color}
                >
                    {level !== undefined ? level : 'medium'}
                </Tag>
            </div>
        )
    }

    function _convertTime(stringDate) {
        return moment(stringDate).format("HH:mm DD/MM/YYYY")
    }

    function _handleChange() {
        const {item, onUpdateSelectedBatches} = props
        const isChecked = _detectChecked()

        onUpdateSelectedBatches(item._id, !isChecked, item.id)
    }

    function _detectChecked() {
        const {item, selectedBatchId} = props

        return selectedBatchId.includes(item._id)
    }
    
    const warningBatch = !!production_times && !!production_times.length && !production_times.every(i => !i || !i.overtime || i.overtime < -1.5)
    const overtimed = !!warningBatch && !!production_times.find(i => !!i && !!i.overtime && i.overtime > 0)
    const almostOvertime = !!warningBatch && !overtimed && !!production_times.find(i => !!i && !!i.overtime && i.overtime >= -1.5 && i.overtime <= 0)
    const wraningStyle = !!warningBatch ? { background: `rgb(${(!!almostOvertime ? "255, 208, 26, 0.3" : (overtimed ? "223, 31, 31, 0.2" : ''))})` } : {}
    const isGiftTag =!!item.tags && Array.isArray(item.tags) && item.tags.includes('gift')
    const isSampleTag =!!item.tags && Array.isArray(item.tags) && item.tags.includes('sample')
    const isFbaTag =!!item.tags && Array.isArray(item.tags) && (item.tags.includes('FBA') || item.tags.includes('fba'))
    const isFastShipTag =!!item.tags && Array.isArray(item.tags) && item.tags.includes('fastship')
    const isUIDSAMPLETag =!!item.tags && Array.isArray(item.tags) && item.tags.includes('UIDSAMPLE')
    const isFastProductionTag =!!item.tags && Array.isArray(item.tags) && item.tags.includes('fastproduction')
    const isTikTokTag =!!item.tags && Array.isArray(item.tags) && item.tags.includes('tiktok')
    const is24hTag =!!item.tags && Array.isArray(item.tags) && item.tags.includes('24h')
    const isCutOff =!!item.tags && Array.isArray(item.tags) && item.tags.includes('cutoff')
    const isCutOffNoel = !!item.tags && Array.isArray(item.tags) && item.tags.includes('cutoff_noel')
    const isCutOffNewYear = !!item.tags && Array.isArray(item.tags) && item.tags.includes('cutoff_new_year')
    const isSLLTag = !!item.tags && Array.isArray(item.tags) && item.tags.includes('SLL')

    return (
        <tr className="BatchesRows" key={item._id} style={wraningStyle}>
            <td className="BatchSelectedAll">
                <input type="checkbox" checked={_detectChecked()} onChange={_handleChange}/>
            </td>
            <td className="BatchName">
                <Link to={`/batches/${item._id}`}>
                    {item.name}
                </Link>
                {
                    _generateLevel(item.level)
                }

                {   
                    isGiftTag && 
                    <div>
                        <Tag color="#6c757d">Hàng tặng</Tag>
                    </div>
                }

                {
                    isSampleTag && 
                    <div>
                        <Tag color="#6c757d">Hàng mẫu</Tag>
                    </div>
                }

                {
                    isFbaTag && 
                    <div>
                        <Tag color="#6c757d">FBA</Tag>
                    </div>
                }

                {
                    isFastShipTag && 
                    <div>
                        <Tag color="#6c757d">Ship nhanh</Tag>
                    </div>
                }

                {
                    isUIDSAMPLETag && 
                    <div>
                        <Tag color="#6c757d">UIDSAMPLE</Tag>
                    </div>
                }

                {
                    isFastProductionTag && 
                    <div>
                        <Tag color="#FFA500">Sản xuất nhanh</Tag>
                    </div>
                }

                {
                    isTikTokTag && 
                    <div>
                        <Tag color="#dc3644">TIKTOK</Tag>
                    </div>
                }

                {
                    is24hTag &&
                    <div>
                        <Tag color="#dc3644">24h</Tag>
                    </div>
                }

                {
                    isCutOff && 
                    <div>
                        <Tag color="#FF6600">cutoff</Tag>
                    </div>
                }

                {
                    isCutOffNoel &&
                    <div>
                        <Tag color="#FF6600">cutoff_noel</Tag>
                    </div>
                }

                {
                    isCutOffNewYear &&
                    <div>
                        <Tag color="#FF6600">cutoff_new_year</Tag>
                    </div>
                }

                {
                    isSLLTag &&
                    <div>
                        <Tag color="#fdb813">SLL</Tag>
                    </div>
                }
            </td>
            <td className="BatchCreated">{_convertTime(item.created_at)}</td>
            <ProductType 
                types={item.product_types} 
                onChangeProductType={onChangeProductType} 
                brand={brand} 
                handleChangeInput={handleChangeInput}
            />
            <td className="BatchStatus">
                <span className={`badge ${color} badge-pill`}>{status}</span>
            </td>
            <td className="BatchItemError">{item.errorItems}</td>
            <td className="BatchPartner">{(partner !== undefined && partner !== null) ? partner.name : '-'}</td>
            <td className="BatchPartner">{(sewing_partner !== undefined && sewing_partner !== null) ? sewing_partner.name : '-'}</td>
            <td className="BatchUserCreated">{item.user_create}</td>
            <td className="BatchNote">{item.note}</td>
        </tr>
    )
}

export default BatchesRows